import { Link, useNavigate, useLocation } from "react-router-dom";
import {
    FaUser, FaMapMarkerAlt, FaHeart, FaTicketAlt,
    FaPhone, FaSignOutAlt, FaChevronRight, FaShoppingCart
} from 'react-icons/fa';

const navItems = [
    { icon: <FaUser size={15} />,         label: "My Profile",  path: "/my-profile"   },
    { icon: <FaShoppingCart size={15} />, label: "My Orders",   path: "/my-orders"    },
    { icon: <FaMapMarkerAlt size={15} />, label: "My Address",  path: "/my-address"   },
    { icon: <FaHeart size={15} />,        label: "Wishlist",    path: "/my-wishlist"  },
    { icon: <FaTicketAlt size={15} />,    label: "Coupons",     path: "/my-coupan"    },
    { icon: <FaPhone size={15} />,        label: "Contact Us",  path: "/user-contact" },
];

const AccountSidebar = ({
    mobileView,
    setMobileView,
    activeMobilePath,
    contentViewName = "content",
}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
        navigate("/user-login");
    };

    const handleMobileNavClick = (item) => {
        if (activeMobilePath === item.path || location.pathname === item.path) {
            // Same page — directly show content
            setMobileView(contentViewName);
        } else {
            // Different page — set flag so that page auto-shows content on load
            sessionStorage.setItem("mob_nav_direct", "true");
            navigate(item.path);
        }
    };

    // Desktop
    const DesktopNavList = () => (
        <div className="acct-nav-list">
            {navItems.map((item) => {
                const isActive = location.pathname === item.path;
                return (
                    <Link
                        key={item.path}
                        to={item.path}
                        className={`acct-nav-item ${isActive ? "acct-nav-item--active" : ""}`}
                    >
                        <span className="acct-nav-icon">{item.icon}</span>
                        <span className="acct-nav-label">{item.label}</span>
                        <FaChevronRight size={11} className="acct-nav-chevron" />
                    </Link>
                );
            })}

            <button className="acct-nav-item acct-nav-item--logout" onClick={handleLogout}>
                <span className="acct-nav-icon"><FaSignOutAlt size={15} /></span>
                <span className="acct-nav-label">Logout</span>
                <FaChevronRight size={11} className="acct-nav-chevron" />
            </button>
        </div>
    );

    // Mobile Menu
    const MobileMenuScreen = () => (
        <div className="mob-menu-screen">
            <div className="mob-nav-list">
                {navItems.map((item) => {
                    const isActive = location.pathname === item.path || activeMobilePath === item.path;
                    return (
                        <div
                            key={item.path}
                            className={`mob-nav-item ${isActive ? "mob-nav-item--active" : ""}`}
                            onClick={() => handleMobileNavClick(item)}
                        >
                            <div className="mob-nav-left">
                                <span className="mob-nav-icon">{item.icon}</span>
                                <span className="mob-nav-label">{item.label}</span>
                            </div>
                            <FaChevronRight size={13} className="mob-nav-chevron" />
                        </div>
                    );
                })}

                <div className="mob-nav-item mob-nav-item--logout" onClick={handleLogout}>
                    <div className="mob-nav-left">
                        <span className="mob-nav-icon mob-nav-icon--logout">
                            <FaSignOutAlt size={15} />
                        </span>
                        <span className="mob-nav-label mob-nav-label--logout">Logout</span>
                    </div>
                    <FaChevronRight size={13} className="mob-nav-chevron" />
                </div>
            </div>
        </div>
    );

    return (
        <>
            <style>{`
                /* ==================== DESKTOP ==================== */
                .acct-sidebar-desktop {
                    width: 230px; min-width: 230px; background: #fff;
                    border-radius: 10px; border: 1px solid #ececec;
                    box-shadow: 0 2px 12px rgba(0,0,0,0.07);
                    height: fit-content; position: sticky; top: 20px;
                }
                .acct-nav-list { display: flex; flex-direction: column; }
                .acct-nav-item {
                    display: flex; align-items: center; gap: 12px;
                    padding: 14px 18px; text-decoration: none; color: inherit;
                    border-bottom: 1px solid #f5f5f5; cursor: pointer;
                    transition: background 0.2s;
                }
                .acct-nav-item:hover { background: #fafafa; }
                .acct-nav-item--active { background: #fffbf0; }
                .acct-nav-item--active .acct-nav-label,
                .acct-nav-item--active .acct-nav-icon { color: #c9a227; font-weight: 600; }

                .acct-nav-item--logout {
                    border-top: 1px solid #f0f0f0 !important;
                    margin-top: 4px;
                    width: 100%;
                    background: none;
                    border: none;
                    text-align: left;
                }
                .acct-nav-item--logout .acct-nav-label {
                    color: #e53935 !important;
                    font-weight: 600;
                }
                .acct-nav-item--logout .acct-nav-icon {
                    color: #e53935 !important;
                }
                .acct-nav-item--logout:hover {
                    background: #ffebee !important;
                }

                /* ==================== MOBILE ==================== */
                .mob-menu-screen { background: #f5f5f5; min-height: 100%; }

                .mob-nav-list { background: #fff; }
                .mob-nav-item {
                    display: flex; align-items: center; justify-content: space-between;
                    padding: 16px 20px; border-bottom: 1px solid #f0f0f0;
                    cursor: pointer;
                }
                .mob-nav-item:active { background: #f9f9f9; }
                .mob-nav-item--active { background: #fffbf0; }
                .mob-nav-item--active .mob-nav-label,
                .mob-nav-item--active .mob-nav-icon { color: #c9a227; font-weight: 600; }

                .mob-nav-left { display: flex; align-items: center; gap: 14px; }
                .mob-nav-icon { width: 26px; color: #f5a623; }
                .mob-nav-icon--logout { color: #e53935; }
                .mob-nav-label { font-size: 14.5px; color: #222; }
                .mob-nav-label--logout { color: #e53935; font-weight: 600; }

                .mob-nav-item--logout {
                    margin-top: 8px;
                    border-top: 6px solid #f5f5f5;
                    border-bottom: none;
                }

                /* Responsive */
                @media (max-width: 768px) {
                    .acct-sidebar-desktop { display: none; }
                    .mob-menu-screen { display: block; }
                }
                @media (min-width: 769px) {
                    .mob-menu-screen { display: none; }
                    .acct-sidebar-desktop { display: block; }
                }
            `}</style>

            {/* Mobile Menu */}
            <div className="acct-mobile-only" style={{ display: mobileView === "menu" ? "block" : "none" }}>
                <MobileMenuScreen />
            </div>

            {/* Desktop Sidebar */}
            <div className="acct-sidebar-desktop">
                <DesktopNavList />
            </div>
        </>
    );
};

export default AccountSidebar;